import { api } from '@/lib/api'
import type { RegisterResponse, TokenResponse, User } from '@/types/user'

export async function loginRequest(email: string, password: string): Promise<TokenResponse> {
  const body = new URLSearchParams({
    grant_type: 'password',
    username: email,
    password,
    scope: '',
    client_id: 'string',
    client_secret: 'changeme',
  })
  const { data } = await api.post<TokenResponse>('/auth/token', body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
  return data
}

export async function registerRequest(email: string, name: string, password: string): Promise<RegisterResponse> {
  const { data } = await api.post<RegisterResponse>('/user/', { email, name, password })
  return data
}

export async function fetchCurrentUser(): Promise<User> {
  const { data } = await api.get<User>('/user/')
  return data
}
